<div class="contratos">
  <app-tabs-navigation
    [tabs]="tabs"
    [mode]="mode"
    position="center"
    appearance="modern"
  ></app-tabs-navigation>
  <router-outlet></router-outlet>
  <app-contratos-footer [link]="'/esteira-apuracao'" [showBackButton]="false"></app-contratos-footer>
</div>
